

import { Injectable, HostListener } from '@angular/core';

import { AngularFirestore, AngularFirestoreCollection } from '@angular/fire/firestore';
import { map, take, debounceTime, first } from 'rxjs/operators';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { NetsolinApp } from '../global';
import { CurBaseService } from './firebase/curbase.service';
// import { NetsolinService } from './netsolin/netsolin.service';
import { ToastrService } from 'ngx-toastr';
import { Observable } from 'rxjs';
import { GlobalService } from './global.service';
import { NetsolinService } from 'src/app/shared/services/netsolin.service';

@Injectable({
  providedIn: "root",
})
export class OappService {
  DEPURANDO = true;
  public datosEmpre: any = {};
  public usuario: any = {};
  public datosapp: any;
  public mostrarbreadcrumbs = false;
  public prefijoemprenetsolin = "";
  public usuarionetsolin = "";
  public urlservirestnetsolin = "";
  public urlwebnetsolin = "";
  public tokennetsolin = "";
  URL_SERVICIOS: string = "";
  //Netsolin_ini
  cargoNetsolin_ini = false;
  multiempresa = false;
  solonetsolin = false;
  sas = false;
  nits_prefijosbd = [];
  firebase = false
  netsolin_ini: any;

  constructor(
    public afs: AngularFirestore,
    private http: HttpClient,
    public globalS: GlobalService,
    private NetsolinService: NetsolinService
  ) {
    this.limpiar();
    console.log("Inicio constructor Oapp");
    //Parametros de netsolin_ini 11 07 22
    
      //
      globalS.getData().subscribe(async (data) => {
        console.log("oappservice ", data);
        if (data.user && data.empresa) {
          this.usuarionetsolin = data.user.id;
          this.tokennetsolin = "Xxcx23232ASAS2323ZDsdc855";
          if (
            this.prefijoemprenetsolin != data.empresa.parNetsolin.prefijoemprenetsolin ||
            this.urlservirestnetsolin != data.empresa.parNetsolin.urlservirestnetsolin
          ) {
            this.prefijoemprenetsolin =
              data.empresa.parNetsolin.prefijoemprenetsolin;
            this.urlservirestnetsolin =
              data.empresa.parNetsolin.urlservirestnetsolin;
            this.urlwebnetsolin =
              data.empresa.parNetsolin.urlwebnetsolin;
            this.solonetsolin = data.empresa.solonetsolin;
            this.NetsolinService.inicializarNetsolin(this);
          }
        } else if(!data.user) {
          this.http.get('assets/dist/netsolin_ini.json').pipe(first()).toPromise().then((data: any) => {
            console.log('netsolin_ini', data);
            this.netsolin_ini = data;
            this.firebase = data['firebase'];
            if (this.firebase == undefined || this.firebase == false) {
              NetsolinApp.urlNetsolin = data['url_netsolins'];
              this.urlservirestnetsolin = data['url_netsolins'];
              this.urlwebnetsolin = data['urlwebnetsolin'];
              NetsolinApp.urlwebnetsolin = data['urlwebnetsolin'];
              this.URL_SERVICIOS = data['url_netsolins'];
              localStorage.setItem('urlNetsolin', data['url_netsolins']);
              this.multiempresa = data['multiempresa'];
              this.sas = data['sas'];
              this.nits_prefijosbd = data['nits_prefijosbd'];
              localStorage.setItem('netsolin_ini', JSON.stringify(data));
              this.cargoNetsolin_ini = true;
            }
        }).catch((err)=>{
          this.limpiar();
        });
        }
        else {
          this.limpiar();
        }
        this.datosapp = {URL_SERVICIOS:this.urlservirestnetsolin};
      });
      console.log("constructor oapp", this);
    //op feb 26 22 por ahora de acuerdo con conjunto debe seleccionar un registro en firebase de acuerdo con el prefijo de la empresa para netsolin
  }
  iniDatosEmpreFB(data) {
    NetsolinApp.urlNetsolin = data.parNetsolin.urlservirestnetsolin;
    this.urlservirestnetsolin = data.parNetsolin.urlservirestnetsolin;
    this.urlwebnetsolin = data.parNetsolin.urlservirestnetsolin;
    NetsolinApp.urlwebnetsolin = data.parNetsolin.urlwebnetsolin;
    this.URL_SERVICIOS = data.parNetsolin.urlservirestnetsolin;
  }

  limpiar() {
    this.datosEmpre = {};
    this.usuario = {};
    this.datosapp;
    this.mostrarbreadcrumbs = false;
    this.prefijoemprenetsolin = "";
    this.usuarionetsolin = "";
    this.urlservirestnetsolin = "";
    this.tokennetsolin = "";
    this.URL_SERVICIOS = "";
  }
}
